module.exports = __webpack_public_path__ + "img/title-4.0b9d285d.png";